import { Box, Grid, Stack, Text } from "@chakra-ui/core";
import React from "react";
import { useParams } from "react-router-dom";
import NavBar from "../../../Components/NavBar";
import { recommendedJobs } from "../../../Data/Jobs";
import SummaryCard from "./SummaryCard";
import TitleCard from "./TitleCard";

function searchFunc(key, array) {
  for (let i = 0; i < array.length; i++) {
    if (array[i].id === key) {
      return array[i];
    }
  }
}

const TitleDescription = ({ title, desc }) => (
  <Stack my="3">
    <Text fontSize="lg">{title}</Text>
    <Text fontSize="md" color="grey">
      {desc}
    </Text>
  </Stack>
);

function ViewJob() {
  const { jobId } = useParams();

  const jobPost = searchFunc(jobId, recommendedJobs);
  // console.log(jobPost);
  return (
    <Box>
      <NavBar />
      <TitleCard jobPost={jobPost} />
      <Grid my="5" templateColumns="0.8fr 2fr" gap="1em">
        <Box>
          <Text ml="3" my="3" fontSize="lg">
            Job Posted By
          </Text>
          <SummaryCard jobPosting={jobPost} />
        </Box>
        <Box mx="10">
          <TitleDescription
            title="Job Description"
            desc={jobPost.description}
          />
          <TitleDescription title="Desired Candidate" desc={jobPost.desired} />
          <TitleDescription title="Company Profile" desc={jobPost.profile} />
          <TitleDescription title="Attachment" desc={jobPost.profile} />
        </Box>
      </Grid>
    </Box>
  );
}

export default ViewJob;
